module.exports = __webpack_public_path__ + "img/brain.ec642fcc.svg";